const ExpoCapacitorStorage = {
  get(key: string): string | null {
    return localStorage.getItem(key);
  },
  set(key: string, value: string): void {
    localStorage.setItem(key, value);
  },
  remove(key: string): void {
    localStorage.removeItem(key);
  },
  keys(): string[] {
    return Object.keys(localStorage);
  },
  clear(): void {
    localStorage.clear();
  },
};

export default ExpoCapacitorStorage;
